enum CallTypes {
    INCOMING_CALL = 'INCOMING_CALL',
    CALLBACK_CALL = 'CALLBACK_CALL',
    END_CALL = 'END_CALL',
    REJECT_CALL = 'REJECT_CALL',
    ACCEPT_CALL = 'ACCEPT_CALL',
    MAKE_CALL = 'MAKE_CALL',
    UPDATE_CALL_STATUS = 'UPDATE_CALL_STATUS',
    CALL_ENDED = 'CALL_ENDED',
    TRANSFER_CALL = 'TRANSFER_CALL',
    HOLD = 'HOLD',
    RESUME = 'RESUME',
    SET_HOLD = 'SET_HOLD',
    CALL_STARTED = 'CALL_STARTED',
    MISSED_CALL = 'MISSED_CALL',
    ADD_CONNECTION = 'ADD_CONNECTION',
    SET_CONNECTIONS = 'SET_CONNECTIONS',
    UPDATE_CONNECTION_STATUS = 'UPDATE_CONNECTION_STATUS',
    CONNECTION_CONNECTING = 'CONNECTION_CONNECTING',
    END_CONNECTION = 'END_CONNECTION',
    TOGGLE_CONNECTIONS = 'TOGGLE_CONNECTIONS',
    CONNECTION_STARTED = 'CONNECTION_STARTED',
    UPDATE_CALL_NOTES = 'UPDATE_CALL_NOTES',
    CONFERENCE_CONNECTIONS = 'CONFERENCE_CONNECTIONS',
    MUTE = 'MUTE',
    UNMUTE = 'UNMUTE',
    SET_SENSITIVE = 'SET_SENSITIVE',
    SEND_DTMF = 'SEND_DTMF',
    SWAP_CONNECTIONS = 'SWAP_CONNECTIONS',
    OUTBOUND_CALL = 'OUTBOUND_CALL',
    LEAVE_CALL = 'LEAVE_CALL',
    RECOVER_CALL = 'RECOVER_CALL',
    INITIATE_LEGACY_MONITORING = 'INITIATE_LEGACY_MONITORING',
    INITIATE_ENHANCED_MONITORING = 'INITIATE_ENHANCED_MONITORING',
    CALL_BARGE = 'CALL_BARGE',
    PARK_CALL_CONTACT_TRANSFER = 'PARK_CALL_CONTACT_TRANSFER',
    SET_SELECTED_CALL = 'SET_SELECTED_CALL',
    COMPLETE_CALL_ACW = 'COMPLETE_CALL_ACW',
    ALLOW_WEB_HID = 'ALLOW_WEB_HID',
    UPDATE_MONITOR_STATUS = 'UPDATE_MONITOR_STATUS',
    SET_MONITOR_STATUS = 'SET_MONITOR_STATUS',
}

export default CallTypes;
